import { useEffect, useRef, useState } from "react";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useTickets = ({
  pageNumber,
  status,
  date,
  showAll,
  withUnreadMessages,
  isGroup,
  filter,
  selectedUserIds,
  selectedConnectionIds,
  queueIds
}) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [count, setCount] = useState(0);

  const abortControllerRef = useRef(null);
  const requestIdRef = useRef(0);


  
  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    setLoading(true);

    const currentRequestId = ++requestIdRef.current;
    if (abortControllerRef.current) abortControllerRef.current.abort();

    const controller = new AbortController();
    abortControllerRef.current = controller;

    const delayDebounceFn = setTimeout(() => {
      const fetchTickets = async() => {
        try {
          const { data } = await api.get("/tickets", {
            params: { pageNumber, status, date, showAll, withUnreadMessages, isGroup, filter, selectedUserIds, selectedConnectionIds, queueIds }
            , signal: controller.signal
          });

          if (currentRequestId !== requestIdRef.current) return;

          setTickets(data.tickets);
          setHasMore(data.hasMore);
          setCount(data.count);
          setLoading(false);
        }
        catch (exception) {
          if (exception.code === "ERR_CANCELED") return;
          console.log("Use Tickets Exception:", exception);
          toastError(exception);
        }
        finally {
          setLoading(false);
        }
      }

      fetchTickets();
    }, 500);

    return () => {
      clearTimeout(delayDebounceFn);
      controller.abort();
    };
  }, [pageNumber, status, date, showAll, withUnreadMessages, isGroup, filter, selectedUserIds, selectedConnectionIds, queueIds])



  //  ************
  //  ** Return **
  //  ************
  return { tickets, loading, hasMore, count };
};

export default useTickets;